/* eslint-disable quotes */
import styles from './Welcome.module.scss';
import { defineComponent, h, ref } from 'vue';
import { version } from '@phi/constants';
import { nice_version_format } from '@phi/util';
import { Button, FormCheckboxWithLabel, Modal, small_height, utility } from '@phi/components';
import { closing_welcome_window } from '../../utility';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import { update_skipped_tutorial } from '@frontend/application-container';

const terms = `
    By proceeding you agree to our <br>
    <a class="link" href="https://phi3d.com/terms-of-service" target="_blank">Terms of Service</a>
    and our <a class="link" href="https://phi3d.com/privacy-policy" target="_blank" >Privacy Policy</a>.
`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    methods: {
        notify_tutorials_skipped(): void {
            display_message_to_user(LOG.INFO, 'This window will only reappear if settings are reset.<br/>You can access the Tutorials at any time through the "i" icon at the top right corner.');
            update_skipped_tutorial();
        },
    },

    render() {
        const skipped = ref(false);
        return h(Modal, {
            show: this.show,
            'onUpdate:show': () => this.$emit('update:show', false),
            id: 'tutorialsModal',
            dismissible: false,
            width: 'narrower',
            draggable: false,
        }, {
            body: () => h('div', {
                class: [
                    small_height() ? utility.margin_gap_3 : utility.margin_gap_5,
                    utility.p_2,
                    utility.center,
                ]
            }, [
                h('h2', { class: utility.bold }, 'Welcome to Phi'),

                h('a', {
                    class: [
                        utility.block,
                        utility.bold,
                        styles.changelog,
                    ],
                    href: 'https://www.phi3d.com/updates',
                    target: '_blank',
                }, `Check out what's new in v${nice_version_format(version)}!`),

                h('p', { class: [styles.thumbnail, utility.pointer] },
                    h('img', {
                        loading: 'lazy',
                        src: 'img/tour.webp',
                        onClick: () => closing_welcome_window(true),
                    }),
                ),

                h(Button, {
                    onClick: () => closing_welcome_window(false),
                }, 'Skip'),

                h(FormCheckboxWithLabel, {
                    value: skipped.value,
                    'onUpdate:value': x => {
                        if (x) this.notify_tutorials_skipped();
                        skipped.value = x;
                    },
                    class: utility.justify_center,
                }, () => 'Don\'t show again for this version'),

                h('div', {
                    class: [
                        styles.terms,
                        utility.m_auto,
                        utility.small,
                    ],
                    innerHTML: terms,
                }),
            ]),
        });
    }
});
